<template>
  <header>
    <span class="image">
      <img v-if="provider.image" :src="provider.image" />
      <i v-else class="el-icon-user"></i>
    </span>

    <div class="detail">
      <h1>{{ provider.name }}</h1>
      <div class="email">{{ provider.specialization }}</div>
      <!-- <router-link to="/account">manage</router-link> -->
    </div>

    <HeaderAction
      :routes="routes"
      :url="url"
      v-bind:count="count"
    ></HeaderAction>
  </header>
</template>

<script>
import Header from "@/module/component/header";
import { mapState, mapGetters } from "vuex";
import providerRoutes from "./routes";

export default {
  name: "provider-header",
  extends: Header,

  props: {
    provider: {
      type: Object,
      required: true,
    },
    url: {
      type: String,
      default: "/",
    },
  },

  data() {
    // Get the child routes of the provider module
    var routes = providerRoutes[0].children.filter((r) => !r.hidden);

    // Store the count for badges
    var count = {};
    routes.forEach((route) => {
      count[route.id] = 0;
    });

    return {
      routes,
      count,
    };
  },

  computed: {
    ...mapState(["routeName"]),
  },

  components: {},
};
</script>

<style lang="scss" scoped>
@import "@/module/app/theme/header.scss";
</style>
